import { Badge } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Bold = styled.span`
  font-weight: 700;
`;

const VerticalListHeader = styled.div`
  ${Badge.S.BadgeWrapper} {
    padding: 0;
  }
`;
export { Bold, VerticalListHeader };
